// extracted by mini-css-extract-plugin
export default {"requirements":"PasswordWithRequirementsInput_requirements__V-iWE"};